<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <app-main></app-main>
  </div>
</template>

<script>
import NprogressContainer from "vue-nprogress/src/NprogressContainer";
import AppMain from "./components/AppMain";

export default {
  name: "app",
  components: {
    NprogressContainer,
    AppMain
  }
};
</script>

<style lang="less" type="text/less">
@import '~animate.css';
.animated {
  animation-duration: .377s;
}
</style>



// WEBPACK FOOTER //
// App.vue?33a79ffe